module.exports = __webpack_public_path__ + "img/logo.e0d21fd2.png";